/** Yeni sekmede açılan hazırlık rotası — çift spinner önlemek için diğer katmanlar bunu tanır */
export function isMeetingPreparePath(pathname) {
  if (!pathname || typeof pathname !== "string") return false;
  return /\/appointments\/meeting-prepare\/[^/]+/.test(pathname);
}

/**
 * Görüşme hazırlık sayfasını yeni sekmede açar (aynı origin, about:blank yok).
 * Randevu başlatma API çağrısı AppointmentPrepareTab içinde yapılır.
 *
 * @param {string|number} appointmentId
 * @returns {{ ok: true } | { ok: false, reason: 'popup_blocked' }}
 */
export function openMeetingPrepareTab(appointmentId) {
  const path = `/appointments/meeting-prepare/${appointmentId}`;
  const tab = window.open(`${window.location.origin}${path}`, "_blank");
  if (!tab) {
    return { ok: false, reason: "popup_blocked" };
  }
  return { ok: true };
}

const CLOSE_RETRY_MS = 150;

/**
 * Görüşme script ile yeni sekmede açıldığı için randevu bitince sekmeyi kapatır.
 * Tarayıcı kapatmaya izin vermezse fallback rotasına gider.
 *
 * @param {(path: string, opts?: object) => void} [navigate]
 * @param {string} [fallbackPath]
 */
export function closeMeetingTab(navigate, fallbackPath = "/appointments") {
  const tryClose = () => {
    try {
      window.close();
    } catch {
      /* tarayıcı reddedebilir */
    }
  };

  tryClose();

  window.setTimeout(() => {
    tryClose();
    if (typeof navigate === "function" && fallbackPath) {
      navigate(fallbackPath, { replace: true });
    }
  }, CLOSE_RETRY_MS);
}
